var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VChip',_vm._g(_vm._b({attrs:{"color":this.parseColor(_vm.color),"dark":_vm.dark,"light":!_vm.dark}},'VChip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }